import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { UIContext } from '../../contexts';
import CategoryGroupHeader from './CategoryGroupHeader';
import VehicleCard from '../VehicleCard';
import EmptyState from '../EmptyState';

/**
 * BR-SM-003: Renders only pre-filtered showcase categories. Categories contain
 * only vehicles matching at least one MSS mapping rule — uncategorized vehicles
 * are excluded upstream by getShowcaseCategories.
 */
const GroupedVehicleGrid = ({ categories }) => {
	const { setOriginCategorySlug } = useContext(UIContext);

	if (categories.length === 0) {
		return <EmptyState type="noResults" />;
	}

	return (
		<>
			{categories.map((category) => (
				<section
					key={category.categorySlug}
					className="mb-4"
					aria-labelledby={`category-${category.categorySlug}`}
					onClickCapture={() =>
						setOriginCategorySlug(category.categorySlug)
					}
				>
					<CategoryGroupHeader
						tabName={category.tabName}
						categorySlug={category.categorySlug}
						vehicleCount={category.vehicles.length}
					/>
					<div className="row d-flex flex-wrap">
						{category.vehicles.map((vehicle) => (
							<div
								key={vehicle.globalVehicleId}
								className="col-md-4 col-sm-6 col-xs-12 d-flex p-3"
							>
								<VehicleCard
									vehicle={vehicle}
									activeCategoryTrim={
										vehicle._activeCategoryTrim || null
									}
								/>
							</div>
						))}
					</div>
				</section>
			))}
		</>
	);
};

GroupedVehicleGrid.propTypes = {
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			tabName: PropTypes.string.isRequired,
			categorySlug: PropTypes.string.isRequired,
			displayOrder: PropTypes.number.isRequired,
			vehicles: PropTypes.arrayOf(
				PropTypes.shape({
					globalVehicleId: PropTypes.string.isRequired,
					// F289003 — annotation set by getShowcaseCategories per
					// category-card-render slot. Drives BR-COMP-002 trim-scoped
					// image precedence in VehicleCard.
					_activeCategoryTrim: PropTypes.string
				})
			).isRequired
		})
	).isRequired
};

export default GroupedVehicleGrid;
